import React, { Component } from "react";
import ReeValidate from 'ree-validate'
import { connect } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { getPaymentToken } from "../store/actions/payments";
import { deleteAccount } from "../store/actions/auth";
import { showAlert } from '../store/actions/alert';
import {convertReadbleFormat} from './../helpers';
import { COLORS } from './../styles/colors';
import Card from './card'

const $ = window.$;

class DeleteAccountModal extends Component {

    constructor(props){
        super(props)
        this.validator = new ReeValidate({
          email: 'required|email'
        })
        this.state = {
          formData: {
            email: '',
          },
          formErrors: this.validator.errors,
          isSubmit: false,
          signUpError: null
        }
    }

    componentDidMount() {
        const { errors } = this.validator
        const { removeError } = this.props
        $('#deleteAccount').on('hidden.bs.modal', () => {
          this.setState({
            formData: {
                email: '',
            },
            signUpError: null,
          }, () => {
            errors.clear();
            removeError();
          });
        })
    }

    handleSubmit = e => {
        e.preventDefault()
        const { removeError } = this.props
        removeError();
        const { formData } = this.state
        const { errors } = this.validator
        this.validator.validateAll(formData)
        .then(success => {
          if (success) {
            this.createNonce({ email: formData.email.toLowerCase() });
          } else {
            this.setState({ formErrors: errors })
          }
        })
    }

  
    async createNonce(formData) {

        const { deleteAccount, showAlert } = this.props;
        deleteAccount({
          email: formData.email,
        }).then((response) => {
            $('#deleteAccount').modal('hide');
            this.setState({
              isSubmit: false,
            });
        }).catch(error =>{
            this.setState({
              isSubmit: false,
              signUpError: error.response.data.message
            });
      });
    }

    handleChange = e => {
      const name = e.target.name
      const value = e.target.value
      const { errors } = this.validator
      errors.remove(name)
      this.setState({ formData: { ...this.state.formData, [name]: value } })
      this.validator.validate(name, value)
        .then(() => {
          this.setState({ formErrors: errors })
        })
    }

   render() {
    const { formData, formErrors, isSubmit, signUpError } = this.state
    return (
        <div className="modal-dialog">
            <div className="modal-content">
                <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal">&times;</button>
                <h3>Enter Detail</h3>
                </div>
                <div style={{'padding':'50px', 'paddingTop': '25px'}} className="modal-body">
                <div className="row">
                  {signUpError !== null && <div className="alert alert-danger">{signUpError}</div>}
                  <form onSubmit={this.handleSubmit} noValidate>
                        <div className="form-group">
                          <label htmlFor="email">Log in email:</label>
                          <input type="email"
                              className="form-control"
                              id="email"
                              placeholder={ "Enter email address"}
                              name="email"
                              onChange={this.handleChange}
                              required
                              value={formData.email}/>
                          { formErrors.has('email') &&
                          <span className="error text-danger">{ convertReadbleFormat(formErrors.first('email')) }</span>
                          }
                    </div>
                 

                  
               
                  
                  <div className="row">
                      <div className="col-md-12">
                      <button type="submit"  style={{ 'width': '100%' }}  className="btn circle btn-light border btn-md" disabled={isSubmit}>Finish</button>
                  </div>
                  </div>
                  </form>
                </div>
                </div>
                <div className="modal-footer">
                <button type="button"  className="btn btn-default" data-dismiss="modal">Close</button>
                </div>
            </div>
            </div>

    )
  }
}

function mapStateToProps(state, ownProps) {
    return {
      paymentToken: state.payments.token
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      deleteAccount: (data) => {
        return dispatch(deleteAccount(data));
      }
    }
  }

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(DeleteAccountModal);



// WEBPACK FOOTER //
// ./src/modals/deleteAccount.js